import { type ReactNode } from 'react';

import { RecordingsCodeBlockProvider } from '@spotify/plugin-confidence-recordings';

import { IssueRecordingsCodeBlock } from './IssueRecordingsCodeBlock';
import { EvidenceIssueContext } from './useEvidenceIssueName';

export { useEvidenceIssueName } from './useEvidenceIssueName';

export const EvidenceIssueProvider = ({
  issueName,
  children,
}: {
  issueName: string;
  children: ReactNode;
}) => (
  <EvidenceIssueContext.Provider value={issueName}>
    <RecordingsCodeBlockProvider component={IssueRecordingsCodeBlock}>
      {children}
    </RecordingsCodeBlockProvider>
  </EvidenceIssueContext.Provider>
);
